import { useQuery } from '@tanstack/vue-query';
import type { Ref } from 'vue';
import type { LookupEntry } from '../types/lookup.ts';

async function fetchEntry(code: string): Promise<LookupEntry | null> {
  const res = await fetch(`/api/lookup/${encodeURIComponent(code.toUpperCase())}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Lookup failed: ${res.status}`);
  return res.json() as Promise<LookupEntry>;
}

export function useCodeLookup(code: Ref<string>) {
  return useQuery({
    queryKey: ['lookup', code],
    queryFn: () => fetchEntry(code.value),
    staleTime: Infinity,
  });
}
